import { isPresent } from '@luminovo/commons';
import { colorSystem, Flexbox, Tag, Text } from '@luminovo/design-system';
import React from 'react';

import { SolutionTagChip } from '../../extractors';

/** Spells out each chip's explanation inline, for hover cards where a nested tooltip is unreachable. */
export const SolutionTagList: React.FunctionComponent<{ chips: SolutionTagChip[] }> = ({ chips }) => {
    const explainedChips = chips.filter((chip) => isPresent(chip.tooltip));

    return (
        <Flexbox
            gap={4}
            sx={{
                flexDirection: 'column',
            }}
        >
            <Flexbox
                gap={4}
                sx={{
                    flexWrap: 'wrap',
                }}
            >
                {chips.map((chip, idx) => (
                    <Tag key={idx} color={chip.color} label={chip.label} attention="low" />
                ))}
            </Flexbox>
            {explainedChips.map((chip, idx) => (
                <Text key={idx} variant="caption" color={colorSystem.neutral[7]}>
                    {chip.label}: {chip.tooltip}
                </Text>
            ))}
        </Flexbox>
    );
};
